import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import IconButton from '@material-ui/core/IconButton';
import { get } from 'lodash';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { Mobile, Default } from 'components/Media';
import { F } from 'components/Ui';
import { CloseExpandIcon } from 'components/Ui/CustomIcons';
import ExpandIcon from 'components/Ui/CustomIcons/ExpandIcon';
import { formatCurrency } from 'utils/common';
import Loader from 'components/Loader';
import { fetchRecentActivities } from '../../actions';
import {
  selectBillingAccountId,
  selectIsFetchingRecentActivities,
  selectRecentUnBilledTransactions,
} from '../../selectors';

import styles from './styles.scss';

const RecentActivitiesList = () => {
  const billingAccountId = useSelector(selectBillingAccountId());
  const isFetchingRecentActivities = useSelector(
    selectIsFetchingRecentActivities(),
  );
  const recentUnBilledTransactions = useSelector(
    selectRecentUnBilledTransactions(),
  );
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (billingAccountId) {
      dispatch(fetchRecentActivities());
    }
  }, [billingAccountId]);

  return (
    <Loader local loading={isFetchingRecentActivities}>
      {recentUnBilledTransactions.length > 0 && (
        <ExpansionPanel className={styles.recentActivitiesList}>
          <ExpansionPanelSummary className={styles.summary}>
            <div style={{ flex: 2 }}>
              <h2>
                <F>Account Activities</F>
              </h2>
            </div>
            <Mobile>
              <IconButton
                className={styles.iconExpanded}
                onClick={() => {
                  setExpanded(!expanded);
                }}
                aria-expanded={expanded}
                aria-label="show more"
              >
                {expanded ? <CloseExpandIcon /> : <ExpandIcon />}
              </IconButton>
            </Mobile>
            <Default>
              <IconButton
                className={styles.iconExpanded}
                onClick={() => {
                  setExpanded(!expanded);
                }}
                aria-expanded={expanded}
                aria-label="show more"
              >
                {expanded ? <CloseExpandIcon /> : <ExpandIcon />}
              </IconButton>
            </Default>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={styles.details}>
            <TableContainer>
              <Table className={styles.tableDelivery} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <F>Details:</F>
                    </TableCell>
                    <TableCell>
                      <F>Total:</F>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {recentUnBilledTransactions.map((item) => (
                    <TableRow
                      key={`${item.transactionType}${item.transactionAmount}`}
                    >
                      <TableCell>{item.transactionType}</TableCell>
                      <TableCell>
                        {formatCurrency(get(item, 'transactionAmount', 0))}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      )}
    </Loader>
  );
};

export default RecentActivitiesList;
